import { httpV1 as http } from '@/services/api';

/** Consulta de "não perturbe" por telefone. */

export async function consultDoNotDisturb(params) {
  return http.get('/qitech/do-not-disturb', { params });
}
